import React from "react";
import { FieldRenderProps } from "react-final-form";
import { FormFieldProps, Form, Label, Dropdown } from "semantic-ui-react";

interface IProps
  extends FieldRenderProps<string, HTMLElement>,
    FormFieldProps {}

const DropdownInput: React.FC<IProps> = ({
  input,
  width,
  options,
  placeholder,
  title,
  meta: { touched, error },
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      {title && <label>{title}</label>}
      <Dropdown
        fluid
        search
        selection
        placeholder={placeholder}
        options={options}
        onChange={(e, data) => input.onChange(data.value)}
        value={input.value}
      />
      {touched && error && (
        <Label basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default DropdownInput;
